export default __webpack_public_path__ + "static/big_event-54cd78c10f240222a6e52f9965ab15a8.webp";